import { c as _c } from "react/compiler-runtime";
import { SvgIcon } from '@mui/material';
const EasyIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fillRule="evenodd" clipRule="evenodd" d="M19.9999 20H17.3391V4H19.9999V20ZM20.9999 21H19.9999H17.3391H16.3391V20V4V3H17.3391H19.9999H20.9999V4V20V21ZM10.6687 20H13.3295V10.2184H10.6687V20ZM13.3295 21H14.3295V20V10.2184V9.2184H13.3295H10.6687H9.6687V10.2184V20V21H10.6687H13.3295ZM7.66084 21H3V15.4368H7.66084V21Z" fill="currentColor" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon viewBox="0 0 24 24" {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default EasyIcon;